import React from "react";
import { Navigate } from "react-router-dom";
const PublicRoute = ({ children }) => {
    const dashboard = localStorage.getItem("dashboard");
    const isChannelPartner = localStorage.getItem("urlKey") === "channel-partner";
    if (dashboard === "UD") {
        const temp = JSON.parse(localStorage.getItem("token_rare"));

        if (temp) {
            if (isChannelPartner) {
                return <Navigate to='/channel-partner/dashboard' />
            }
            return <Navigate to="/dashboard" />;
        }
    }

    return children;
};

export default PublicRoute;
